// extracted by mini-css-extract-plugin
export default {"root":"ShippingLines_root__lLbuH","info":"ShippingLines_info__6PcZM"};